import { CurrencySetting } from "../../type";

export enum OlympusGloryPinTypeEnum {
  MultiplierPin = 100,
  SymbolPin = 200,
  SkullPin = 300,
}

export enum OlympusGloryBingoSymbolEnum {
  BingoSymbolTrident = 201,
  BingoSymbolPlutoBident = 202,
  BingoSymbolFlower = 203,
  BingoSymbolThunder = 204,
  BingoSymbolHolyGrail = 205,
  BingoSymbolBowArrow = 206,
  BingoSymbolHarp = 207,
  BingoSymbolHammers = 208,
  BingoSymbolSnakes = 209,
}

export enum OlympusGloryMultiplierEnum {
  Multiplier1 = 1,
  Multiplier2 = 2,
  Multiplier4 = 4,
  Multiplier6 = 6,
  Multiplier8 = 8,
  Multiplier10 = 10,
  Multiplier12 = 12,
}

export enum OlympusGloryBallTypeEnum {
  Regular = 1,
  Bonus = 2,
  Initialize = 3,
}

export enum OlympusGloryBingoRewardTypeEnum {
  MultiplierReward = 500,
  ExtraBallsReward = 600,
}

export type Setting = {
  currencies: CurrencySetting[];
  minBallCount: number;
  maxBallCount: number;
  payoutMultipliers: number[];
  bonusPayoutMultipliers: number[];
};

export type OlympusGloryHistoryData = {
  ballCount: number;
  bonusBalls: number;
  results: OlympusGloryBallResult[];
};

export type OlympusGloryBallResult = {
  ballIndex: number;
  ballType: OlympusGloryBallTypeEnum;
  newBingoCard: boolean;
  bingoCard: OlympusGloryBingoCard;
  multiplier: number;
  payout: number;
  pins: { [k: number]: OlympusGloryPin };
  resultPin: number;
  exchangePinFrom: OlympusGloryPin;
  triggeredReward: OlympusGloryBingoReward;
  bingoActivated: { x: number; y: number };
};

export type OlympusGloryPin = {
  position: number;
  type: OlympusGloryPinTypeEnum;
  multiplier: number;
  bingoSymbol: OlympusGloryBingoSymbolEnum;
};

export type OlympusGloryBingoReward = {
  type: OlympusGloryBingoRewardTypeEnum;
  multiplier: number;
  freeBalls: number;
  symbols: OlympusGloryBingoSymbol[];
};

export type OlympusGloryBingoCard = {
  rewards: OlympusGloryBingoReward[];
  symbols: OlympusGloryBingoSymbol[][];
};

export type OlympusGloryBingoSymbol = {
  activated: boolean;
  symbolEnum: OlympusGloryBingoSymbolEnum;
};
